import { render } from "./MobileSubmitLastmile.vue?vue&type=template&id=442ad12c"
import script from "./MobileSubmitLastmile.vue?vue&type=script&lang=js"
export * from "./MobileSubmitLastmile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__